import { asyncThunkWrapper } from "../thunkHandler";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASEURI, headers } from "../../utils/helper";



// Lock appointment slot
// export const handleLockSlot = createAsyncThunk(
//     "lockSlot",
//     async (data, thunkAPI) => {
//         const { specialistId, startTimeUTC, endTimeUTC, timeZone } = data;

//         return asyncThunkWrapper(
//             {
//                 data: {
//                     specialistId,
//                     startTimeUTC,
//                     endTimeUTC,
//                     timezone: timeZone
//                 },
//                 method: "POST",
//                 headers: headers(),
//                 url: `${BASEURI}/member/appointments/lock-slot`,
//             },
//             thunkAPI
//         );
//     }
// );

export const handleLockSlot = createAsyncThunk(
    "lockSlot",
    async (data, thunkAPI) => {

        const {
            specialistId,
            slotId,
            date,
            timeZone
        } = data;

        return asyncThunkWrapper(
            {
                data: {
                    specialistId,
                    slotId,
                    date,
                    timezone: timeZone,
                },

                method: "POST",

                headers: headers(),

                url: `${BASEURI}/member/appointments/lock-slot`,
            },
            thunkAPI
        );
    }
);
// Confirm booking slot
export const handleConfirmBooking = createAsyncThunk(
    "confirmBooking",
    async (data, thunkAPI) => {
        return asyncThunkWrapper(
            {
                data,
                method: "POST",
                headers: headers(),
                url: `${BASEURI}/member/appointments/confirm-booking`,
            },
            thunkAPI
        );
    }
);


// Retrieve member appointments
export const handleRetrieveMemberAppointments = createAsyncThunk(
    "retrieveAll",
    async (data, thunkAPI) => {
        const params = {
            type: data?.type || "confirmed", // Default to "confirmed" mapping
            limit: data?.limit || 10,
            currentPage: data?.currentPage || null,
            timeZone: data?.timeZone,
            date: data?.date || null,
            search: data?.search || "",
            startDate: data?.startDate || null,
            endDate: data?.endDate || null,
            status: data?.status || null,
        };

        return asyncThunkWrapper(
            {
                params,
                method: "GET",
                headers: headers(),
                url: `${BASEURI}/member/appointments/retrieve-all`,
            },
            thunkAPI,
            {
                toast: false,
            }
        );
    }
);




// Cancel appointment by member
export const handleCancelAppointment = createAsyncThunk(
    "update",
    async (data, thunkAPI) => {
        return asyncThunkWrapper(
            {
                data: data?.formData,
                method: "PUT",
                headers: headers(),
                url: `${BASEURI}/member/appointments/cancel/${data?.id}`,
            },
            thunkAPI,
        );
    }
);

// Member marks specialist as no show
export const handleMemberMarkNoShow = createAsyncThunk(
    "update",
    async (id, thunkAPI) => {
        return asyncThunkWrapper(
            {
                method: "PUT",
                headers: headers(),
                url: `${BASEURI}/member/appointments/no-show/${id}`,
            },
            thunkAPI,
            { successToast: true, successMsg: "Marked as No Show successfully!" }
        );
    }
);

export const handleCompleteAppointment = createAsyncThunk(
    "completeAppointment",
    async ({ id, roomId }, thunkAPI) => {
        return asyncThunkWrapper(
            {
                method: "PATCH",
                headers: headers(),
                url: `${BASEURI}/member/appointments/complete/${id}`,
                data: {
                    roomId,
                },
            },
            thunkAPI,
            {
                successToast: true,
                successMsg: "Appointment marked as complete successfully!",
            }
        );
    }
);
